import React from 'react';
import PropTypes from 'prop-types';
import './ThreeDotsDropdown.scss';

const ThreeDotsDropdown = React.forwardRef(({ children, onClick }, ref) => (
  <button
    type="button"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <i className="zwicon-more-h actions__item" />
    {children}
  </button>
));

ThreeDotsDropdown.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};


export default ThreeDotsDropdown;
